import React from "react";
import { Alert } from "react-bootstrap";

const InlineAlert = (props) => {


    return (
        <Alert
            variant={props.variant}
            onClose={props.closeMe}
            dismissible
        >
            <Alert.Heading>
                Oh! Seems like something is wrong!
            </Alert.Heading>
            <p key={props.key}>{props.errorMessage}</p>
      </Alert>
    )
}

export default InlineAlert;